import React, { useMemo } from 'react';
import { CountBadge } from '@europrocurement/flexy-components';
import useActivitiesHook from '../../../hooks/useActivitiesHook';

const DossierNotesTabTitle: React.FunctionComponent = function () {
    const { activities } = useActivitiesHook({
        useMemoClient: true,
        requestLogActionLimited: false,
    });

    const noteActivities = useMemo(() => activities.filter((a) => a.type === 'note'), [activities]);

    const hasImportantNote = useMemo(
        () => noteActivities.some((a) => a.noteType === 'important'),
        [noteActivities],
    );

    return (
        <CountBadge
            count={noteActivities.length}
            color={hasImportantNote ? 'warning' : 'primary'}
            bgVariant="main"
        />
    );
};

export default DossierNotesTabTitle;
